import { Option } from "@inrev/core";
import { DateTime } from "luxon";
import { type FC } from "react";
import { calculateDelta } from "../calculateDelta";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { computeWorkingCapital, getWorkingCapitalFYEValue } from "../utils/financialMetricValues";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type WorkingCapitalFYECardProps = {
	recentFYE?: FinancialPeriodBundle;
	previousFYE?: FinancialPeriodBundle;
};

export const WorkingCapitalFYECard: FC<WorkingCapitalFYECardProps> = ({
	recentFYE,
	previousFYE,
}) => {
	const periodEndDate = recentFYE?.period?.periodEndDate;
	const recentYear = Option.map(periodEndDate, (date) => DateTime.fromISO(date).toFormat("yy"));
	const label = `Working Capital (FYE${recentYear ? ` '${recentYear}` : ""})`;

	const recentWorkingCapital = computeWorkingCapital(recentFYE);
	const previousWorkingCapital = computeWorkingCapital(previousFYE);

	const value = getWorkingCapitalFYEValue(recentFYE);
	const delta = Option.doWith(
		{ recentWorkingCapital, previousWorkingCapital },
		({ recentWorkingCapital, previousWorkingCapital }) =>
			calculateDelta(recentWorkingCapital, previousWorkingCapital),
	);

	return (
		<FinancialMetricCard
			testId="working-capital-fye-card"
			label={label}
			value={value}
			delta={delta}
		/>
	);
};
